import React from "react";
import { useState } from "react";
import {
  AEAutoComplete,
  AEFile,
  Card,
  CardBody,
} from "../../../../../../_metronic/_partials/controls";
import { useIntl } from "react-intl";

const BANK_DATA = {
  awb: {
    rib: "007570000207730040117624",
    bank_name: "Attijari Wafabank",
  },
  cih: {
    rib: "230570425801622500840004",
    bank_name: "CIH BANK",
  },
};
const BankTransfer = ({ _props, bank, amount }) => {
  const { formatMessage } = useIntl();
  const [bankAccount, setbankAccount] = useState("");
  const MAD1 = formatMessage({ id: "BANK.AMOUNT.MAD1" });
  const MAD2 = formatMessage({ id: "BANK.AMOUNT.MAD2" });
  return (
    <div>
      <div className="form-group row py-1">
        <AEAutoComplete
          {..._props("bank", "BANK", "autocomplete")}
          options={[
            { id: "awb", label: "BANK_NAME.WAFABANK" },
            { id: "cih", label: "BANK_NAME.CIH" },
          ]}
          getOptionLabel={o => o.label ? formatMessage({ id: o?.label }) : o}
        />
      </div>

      <Card>
        <CardBody>
          <div className="row">
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {formatMessage({ id: "BANK.ACOUNT_NAME" })}
            </div>
            <div className="col-6">Emywork</div>
          </div>
          <div className="row">
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {formatMessage({ id: "BANK.ACOUNT_NUMBER" })}
            </div>
            <div className="col-6">{BANK_DATA[bank].rib}</div>
          </div>
        </CardBody>
      </Card>

      <div className="form-group row py-1">
        <label htmlFor=""> {formatMessage({ id: "BANK_TRANSFER.UPLOAD" })}</label>
        <div className={"col-lg-12"}>
          <AEFile
            {..._props("attachments", "ATTACHMENTS")}
            multiple
            accept={"image/*"}
          />
        </div>
      </div>
      <hr />

      <Card>
        <CardBody>
          <div className="row">
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {formatMessage({ id: "BANK.DEPOSIT_AMOUNT" })}
            </div>
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {amount} {amount <= 10 ? MAD2 : MAD1}
            </div>
          </div>
          {/* <div className="row">
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {formatMessage({ id: "BANK.AMOUNT.FEES" })}
            </div>
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {(amount * 0.1).toFixed(2)} {(amount * 0.1).toFixed(2) <= 10 ? MAD2 : MAD1}
            </div>
          </div> */}
          {/* <div className="row">
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {formatMessage({ id: "BANK.AMOUNT.TOTAL" })}
            </div>
            <div className="col-6" style={{ fontWeight: "bold" }}>
              {(amount * 1.1).toFixed(2)} {(amount * 1.1).toFixed(2) <= 10 ? MAD2 : MAD1}
            </div>
          </div> */}
        </CardBody>
      </Card>
    </div>
  );
};

export default BankTransfer;
